module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/transform.js
// module id = ./node_modules/readable-stream/transform.js
// module chunks = 5